import { render, staticRenderFns } from "./watchHistory.vue?vue&type=template&id=10b3ff8c"
import script from "./watchHistory.vue?vue&type=script&lang=js"
export * from "./watchHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports